<h2 mat-dialog-title class="dialog-title">
  <h3>PDPM COMPONENTS DETAILS</h3>

  <button mat-icon-button (click)="closePopUp()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="details-content">

  <div class="pdpm-card">    

    <div class="component-row" *ngFor="let item of pdpmData">

      <div class="left-section">

        <div class="icon-box" [ngStyle]="{'background-color': '#e4f1ff','color': '#e4f1ff'}">
         <span class="icon-text">{{ item.icon }}</span>
        </div>

        <div class="component-info">

          <div class="component-name" *ngIf="item.title!='Assessment_Indicator'">
           <strong>{{ item.title }}</strong>  - {{item.data.ClinicalCategory}}   - {{ item.data.CMG }}  {{ item.data.EstRate }}
            / {{ item.data.CaseMixIndex }}
            / {{ item.data.HIPPSCharacter }}
          </div>
          <div class="component-name" *ngIf="item.title=='Assessment_Indicator'">
           <strong>{{ item.title }}</strong> - {{item.data.ClinicalCategory}} -  {{ item.data.CMG }}  {{ item.data.EstRate }}
            {{ item.data.assessment_indicator_code }}
            / {{ item.data.assessment_type }}   
          </div>

          <!-- <div class="component-subtitle">
            {{item.data.ClinicalCategory}}           
          </div> -->


          <div class="component-subtitle">
          <strong class="desc-label">Description:</strong>
            {{ item.data.Description }}  
          </div>

        </div>

      </div>

    </div>

  </div>

 
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="closePopUp()">
    Close
  </button>
</mat-dialog-actions>